import { useAppMutation } from '@/shared/hooks/useAppMutation';
import { AppError } from '@/shared/types/AppError';
import { HookOptions } from '@/shared/types/HookOptions';
import { SerializedContent, StoryGenerationOptions } from '@storyverse/shared';
import { storyAIService } from '../services/story.ai.service';

export const useGenerateStoryMutation = (options?: HookOptions<SerializedContent[], AppError, StoryGenerationOptions>) => {
    return useAppMutation<SerializedContent[], AppError, StoryGenerationOptions>({
        mutationFn: (data: StoryGenerationOptions) => storyAIService.generateStory(data),
    }, options);
};
